(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-featured-orbit"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tg-orbit]').forEach((section) => {
    const rail = section.querySelector('[data-tg-orbit-rail]')
    const toggle = section.querySelector('[data-tg-orbit-toggle]')
    if (!rail) return
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    let paused = reduceMotion
    let dragging = false
    let startX = 0
    let startScroll = 0
    let frame = 0
    const tick = () => {
      if (!paused && !dragging && rail.scrollWidth > rail.clientWidth) {
        rail.scrollLeft += 0.28
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1) rail.scrollLeft = 0
      }
      frame = requestAnimationFrame(tick)
    }
    const setPaused = (value) => {
      paused = value
      if (toggle) toggle.querySelector('span').textContent = paused ? toggle.dataset.resume : toggle.dataset.pause
    }
    toggle?.addEventListener('click', () => {
      const userPaused = !paused
      toggle.dataset.userPaused = userPaused ? 'true' : ''
      setPaused(userPaused)
    })
    rail.addEventListener('mouseenter', () => { if (!reduceMotion) paused = true })
    rail.addEventListener('mouseleave', () => { if (!reduceMotion && !toggle?.dataset.userPaused) paused = false })
    rail.addEventListener('focusin', () => { paused = true })
    rail.addEventListener('focusout', () => { if (!reduceMotion) paused = false })
    rail.addEventListener('pointerdown', (event) => {
      dragging = true
      startX = event.clientX
      startScroll = rail.scrollLeft
      rail.setPointerCapture(event.pointerId)
    })
    rail.addEventListener('pointermove', (event) => {
      if (dragging) rail.scrollLeft = startScroll - (event.clientX - startX)
    })
    rail.addEventListener('pointerup', () => { dragging = false })
    frame = requestAnimationFrame(tick)
    document.addEventListener('shopify:section:unload', () => cancelAnimationFrame(frame), { once: true })
  })

  } catch(e) { console.error(e); }
})();
})();
